var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 22L11.8355 16.8191L7 14.5L11.8355 12.1316L14 7L16.2105 12.1316L21 14.5L16.2105 16.8191L14 22Z",
    fill: "#4644B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10L3.10855 6.54605L0 5L3.10855 3.42105L4.5 0L5.92105 3.42105L9 5L5.92105 6.54605L4.5 10Z",
    fill: "#4644B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleIcon);
export default __webpack_public_path__ + "static/media/sparkleIcon.18ee350eaaae8c06f9c40ac4f38466dc.svg";
export { ForwardRef as ReactComponent };